export default {
  name: 'CompanyDataSearch',
  props: {
    searchOptions: {
      type: Object,
      default: () => {}
    },
    searchButtonSize: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentReq: null,
      dataResponse: [],
      loading: false,
      resultCount: 0
    };
  },
  components: {
  },
  computed: {
    checkboxOption () {
      return { title: '', bicon: 'check' };
    }
  },
  methods: {
    saveResult (e) {
      this.$emit(
        'selectedResult',
        this.dataResponse.companies.find((company) => company.selectedValue)
      );
      this.close();
    },
    selectSearchResult (index, check) {
      if (check) {
        const vm = this;
        this.dataResponse.companies.forEach(function callback (searchResultValue, searchResultValueIndex) {
          if (searchResultValueIndex !== index) {
            vm.dataResponse.companies[searchResultValueIndex].selectedValue = false;
          }
        });
        this.$forceUpdate();
      }
    },
    close (e) {
      this.$refs['modal-window'].hide();
    },
    show () {
      this.$refs['modal-window'].show();
    },
    searchAction () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      let path = this.$store.getters.getD365SupportUrl() + '/api/claviz/register/search';
      const filterData = { simple: true };
      const searchData = this.BasicHelper.cloneObject(this.searchOptions);
      if (Object.keys(searchData).length > 0) {
        Object.keys(searchData).forEach((key) => {
          if (searchData[key] != null && searchData[key] != '') {
            filterData[key] = searchData[key];
          }
        });
      }
      path = this.ApiRequest.addGetParamsToPath(path, filterData);
      this.loading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          if (response.data.companies) {
            let setDefault = false;
            response.data.companies.forEach((company) => {
              if (company.terminated == null && !setDefault) {
                company.selectedValue = true;
                setDefault = true;
              }
            });
            this.resultCount = response.data.companies.length;
          }
          this.dataResponse = response.data;
          this.show();
        }
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        }
        this.loading = false;
      });
    },
    canSave () {
      return !!this.dataResponse.companies?.find((company) => company.selectedValue);
    }
  },
  mounted () {}
};
